import { missingWidget } from '../../utils/helpers';

export default function socialHeadlines() {
  const widgetName = 'socialHeadlines';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof socialHeadlinesOpts === 'undefined' ? null : socialHeadlinesOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($widget, {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      showDescription: true,
      hasImages: false,
      lazyLoadImages: false,
      imageIsBackground: false,
      textOverImage: false,
      itemsPerPanel: 1,
      maxItemsVisible: 1,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createSocialHeadlines(data.items);
          resolve(true);
        } else {
          $widget.remove();
          resolve(false);
        }
      },
    });
  });

  function createSocialHeadlines(widgetData) {
    const $socialItem = $widget;
    const { Title, Description } = widgetData[0];

    $socialItem.replaceWith(`
      <div class="social-text">
        <h3>${Title}</h3>
        ${Description === '' ? '' : `<span>Every contribution helps care for injured first responders!</span>`}
      </div>
    `);
  }
}
